
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/destinations/slack",
      function () {
        return require("private-next-pages/destinations/slack.mdx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/destinations/slack"])
      });
    }
  